<template lang="pug">
#self
  main.relative.text-gray-700
    section.relative.shadow-md.rounded.overflow-hidden
      .absolute.inset-0.bg-white.opacity-75

      .relative
        h2.text-xl.uppercase.tracking-wider.p-4 Change Password

        form.p-4(@submit.prevent="submit")
          .mb-4.relative.h-12.rounded.shadow.overflow-hidden
            .absolute.inset-0.pl-16
              input.h-12.w-full.px-4(placeholder="New Password" type="password" name="newpassword" v-model="newpassword")
            label.text-xs.uppercase.tracking-wider.absolute.inset-0.w-16.flex.items-center.justify-center.bg-gray-200 New

          .mb-4.text-red-500.text-sm(v-if="error") {{ error }}

          button.rounded.shadow.w-full.h-12.bg-teal-500.text-white(class="hover:bg-teal-600" :disabled="isSubmitting") Update

  hr.mt-4.relative

  section.mt-4.text-right.relative
    a.text-xs.font-bold.tracking-wider.uppercase.px-4.py-2.rounded.shadow.bg-gray-300.text-gray-700(href="/api/admin/logout" class="hover:bg-gray-100 hover:text-gray-900")
      i.fa.fa-sign-out.mr-2
      span Logout

</template>

<script>
import axios from 'axios'
import { createComponent, ref } from '@vue/composition-api'

export default createComponent({
  setup (props, context) {
    const newpassword = ref('')
    const error = ref('')
    const isSubmitting = ref(false)

    async function submit () {
      if (isSubmitting.value) {
        return
      }

      error.value = ''
      isSubmitting.value = true

      try {
        await axios.post('/api/admin/updatepassword', {
          newpassword: newpassword.value
        })

        newpassword.value = ''
      } catch (err) {
        error.value = err.response.data.message
      }

      isSubmitting.value = false
    }

    return {
      newpassword,
      error,
      isSubmitting,
      submit
    }
  }
})
</script>
